export class Distance{

  static EarthRadius = 6371000;





  static degreesToRadians(Value) {
    return Value * Math.PI / 180;
  }

  static distanceBetweenPoints(lat1, lon1, lat2, lon2) {
    let dLat = this.degreesToRadians(lat2-lat1);
    let dLon =  this.degreesToRadians(lon2-lon1);
    lat1 =  this.degreesToRadians(lat1);
    lat2 =  this.degreesToRadians(lat2);

    let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    let d = Distance.EarthRadius * c;
    return d;
  }
}
